export default __webpack_public_path__ + "static/charter-e982aed237856fc8a6839286a5426a79.png";